// src/components/Contact.js
import React from "react";
import "./Contact.css";

function Contact() {
  return (
    <section id="contact" className="contact-section">
      <div className="contact-inner">
        <span className="contact-badge">Contacto</span>
        <h2>¿Hablamos?</h2>
        <p>
          ¿Tienes una idea o proyecto en mente? Nos encantaría escucharte
          y ayudarte a hacerlo realidad.
        </p>
        <a href="mailto:appdgmdesign@gmail.com" className="email-pill">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="2" y="4" width="20" height="16" rx="2" />
            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
          </svg>
          appdgmdesign@gmail.com
        </a>
      </div>
    </section>
  );
}

export default Contact;
